import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';
import { IUIconfig } from '../models/ui-config';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  _layoutConfig: BehaviorSubject<IUIconfig>;

  constructor(private _mediaObserver: BreakpointObserver) {
    this._layoutConfig = new BehaviorSubject<IUIconfig>({singlePage: true, matches: false, breakpoints: {}});

    this._mediaObserver.observe('(max-width: 991px)').subscribe(state =>{
      this._layoutConfig.next({...this._layoutConfig.getValue(), ... state});
    });
  }

  set hideSidebarAndNav(value: boolean){
    this._layoutConfig.next({...this._layoutConfig.getValue(), singlePage: value});
  }

  get layoutConfig(){
    return this._layoutConfig.asObservable();
  }

  get windowRef(){
    return window;
  }

}
